import React from "react";
import {connect} from "react-redux";
import MenuItem from "material-ui/MenuItem";
import ExitIcon from "material-ui/svg-icons/action/power-settings-new";
import {userLogout, translate} from "admin-on-rest";
import {BMTheme} from "../BMTheme";

const LogoutButton = ({userLogout, translate}) => (
  <MenuItem
    style={{color: BMTheme.icons.color}}
    className="logout"
    leftIcon={<ExitIcon color={BMTheme.icons.color} />}
    primaryText={translate("navigation.logout")}
    onClick={userLogout}
  />
);

export default translate(connect(undefined, {userLogout})(LogoutButton));



// WEBPACK FOOTER //
// ./src/components/LogoutButton.js